
import React, { useContext, useState } from 'react'

const AuctionsContext = React.createContext()
const { Provider } = AuctionsContext

const defaultAuctionsState =
{
	auctionId: undefined,
	sellerInventoryTab: 'auction',
	searchRequest:
	{
		pageIndex: 0,
		pageSize: 15,
		serialNumber: '',
		makes: [],
		models: [],
		yearFrom: null,
		yearTo: null,
		odometerFrom: null,
		odometerTo: null,
		priceFrom: null,
		priceTo: null,
		sortColumn: 'Year',
		sortDirection: 'ASC'
	},
	auction: {
		auctionId: undefined,
		oemId: undefined,
		auctionStateId: undefined,
		created: undefined,
		auctionStartTime: Date.now(),
		auctionEndTime: Date.now(),
		settlementPeriodHours: undefined,
		isModified: false,
		auctionTiers: [{
			auctionTierMembers: []
		}],
		auctionVehicle: {
			auctionVehicleId: undefined,
			auctionId: undefined,
			vehicleId: undefined,
			startPrice: undefined,
			reservePrice: undefined,
			buyNowPrice: undefined,
			marketPrice: undefined,
			daysInInventory: undefined,
			programId: undefined,
			vehicle: {
				vehicleId: undefined,
				oemId: undefined,
				externalTrackingNumber: undefined,
				make: undefined,
				mileage: undefined,
				mileageUoM: undefined,
				model: undefined,
				mvdaDisclosures: undefined,
				serialNumber: undefined,
				year: undefined,
				turnInDate: undefined,
				turnInMileage: undefined,
				dealerDecision: undefined,
				dealerCode: undefined,
				dateCreated: undefined,
				timeVehicleGrounded: undefined,
				trim: undefined,
				oemName: undefined,
				location: undefined,
				stockNumber: undefined,
				warrantyStartDate: undefined,
				assetTypeId: undefined,
				inventoryTypeId: undefined,
				programId: undefined,
				series: undefined,
				engine: undefined,
				drivetrain: undefined,
				transmission: undefined,
				exteriorColor: undefined,
				interiorColor: undefined
			}
		}
	},
	memberSearchRequest: { pageIndex: 0, pageSize: 15, makes: [], models: [], provinces: [], yearFrom: undefined, yearTo: undefined, odometerFrom: undefined, odometerTo: undefined, priceFrom: undefined, priceTo: undefined, proximityPostal: '', proximityRange: null, sortColumn: '', sortDirection: '', userCoordinates: undefined, componentName: '', viewWatchlist: false },
	selectedAuctionListItem:
	{
		auctionId: 0,
		auctionTierId: 0,
		auctionTierExpiryInSeconds: 0,
		auctionTierMemberId: 0,
		auctionVehicleId: 0,
		vehicleId: 0,
		buyNowPrice: undefined,
		year: 0,
		make: '',
		model: '',
		serialNumber: '',
		cylinders: 0,
		displacement: '',
		engine: '',
		drivetrain: '',
		transmission: '',
		exteriorColor: '',
		interiorColor: '',
		locationStreet: '',
		locationCity: '',
		locationProvince: '',
		locationPostal: '',
		mileage: undefined,
		totalDamages: undefined,
		leftFrontImageUrl: '',
		proximity: undefined,
		vehicleInspectionPictures: []
	},
	backRoute: '',
	notes: [],
	memberPagingResult:  { pageCollection: [], totalRecords: 0 }
}

const AuctionsProvider = (props) =>
{
	const [auctionId, setAuctionId] = useState(defaultAuctionsState.auctionId)
	const [sellerInventoryTab, setSellerInventoryTab] = useState(defaultAuctionsState.sellerInventoryTab)
	const [sellerPendingSubFilter, setSellerPendingSubFilter] = useState('all')
	const [sellerTabStatusFilter, setSellerTabStatusFilter] = useState('all')
	const [searchRequest, setSearchRequest] = useState(defaultAuctionsState.searchRequest)
	const [auction, setAuction] = useState(defaultAuctionsState.auction)
	const [memberSearchRequest, setMemberSearchRequest] = useState(defaultAuctionsState.memberSearchRequest)
	const [selectedAuctionListItem, setSelectedAuctionListItem] = useState( { selectedAuctionListItem: defaultAuctionsState.selectedAuctionListItem, backRoute: defaultAuctionsState.backRoute })
	const [backRoute, setBackRoute] = useState('')
	const [notes, setNotes] = useState([])
	const [memberPagingResult, setMemberPagingResult] = useState({ pageCollection: [], totalRecords: 0 })

	return <Provider value={{
		auctionId,
		setAuctionId,
		sellerInventoryTab,
		setSellerInventoryTab,
		sellerPendingSubFilter,
		setSellerPendingSubFilter,
		searchRequest,
		setSearchRequest,
		auction,
		setAuction,
		memberSearchRequest,
		setMemberSearchRequest,
		selectedAuctionListItem,
		setSelectedAuctionListItem,
		backRoute,
		setBackRoute,
		notes,
		setNotes,
		memberPagingResult,
		setMemberPagingResult,
		sellerTabStatusFilter,
		setSellerTabStatusFilter,
	}}>
		{ props.children }
	</Provider>
}

export { AuctionsProvider, AuctionsContext }
